/** Window-level state that pages report to the title bar. */
export const shell = $state({
  /** Hosting a room: leaving the host page would orphan the running stream. */
  hosting: false,
})
